import { render, staticRenderFns } from "./setCreditStuProbation.vue?vue&type=template&id=28ffe8f4&"
import script from "./setCreditStuProbation.vue?vue&type=script&lang=js&"
export * from "./setCreditStuProbation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports